(function () {
  if (window.__GWA_CARD_SWATCHES_JS_LOADED__) return;
  window.__GWA_CARD_SWATCHES_JS_LOADED__ = true;

  function sizedShopifyImg(url, size) {
    if (!url) return '';
    try {
      var imageUrl = new URL(url, document.baseURI);
      imageUrl.searchParams.set('width', size);
      return imageUrl.href;
    } catch (error) {
      return url;
    }
  }

  function setImg(img, url, srcset) {
    if (!img || !url) return;
    // Set candidates before src so a swatch does not start a redundant fallback request.
    if ((img.getAttribute('srcset') || '') !== srcset) {
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
  }

  function swapCardImage(card, imgUrl, imageWidth) {
    if (!card || !imgUrl) return;

    var mainImg = card.querySelector('[data-card-main-image]');
    var secondImg = card.querySelector('[data-card-secondary-image]');
    var maxWidth = Math.min(Number(imageWidth) || 1066, 1066);
    var widths = [165, 360, 533, 720, 940, 1066].filter(function (width) { return width < maxWidth; });
    widths.push(maxWidth);
    var srcset = widths.map(function (width) {
      return sizedShopifyImg(imgUrl, width) + ' ' + width + 'w';
    }).join(', ');
    var sized = sizedShopifyImg(imgUrl, Math.min(533, maxWidth));

    if (mainImg) setImg(mainImg, sized, srcset);
    if (secondImg) setImg(secondImg, sized, srcset);
  }

  function restoreDefaultCardImage(card) {
    if (!card) return;

    var mainImg = card.querySelector('[data-card-main-image]');
    var secondImg = card.querySelector('[data-card-secondary-image]');

    if (mainImg) {
      var mainDefault = mainImg.getAttribute('data-default-src');
      if (mainImg.__gwaDefaultSrcset === undefined) mainImg.__gwaDefaultSrcset = mainImg.getAttribute('srcset') || '';
      if (mainDefault) setImg(mainImg, mainDefault, mainImg.__gwaDefaultSrcset);
    }

    if (secondImg) {
      var secondDefault = secondImg.getAttribute('data-default-src');
      if (secondImg.__gwaDefaultSrcset === undefined) secondImg.__gwaDefaultSrcset = secondImg.getAttribute('srcset') || '';
      if (secondDefault) setImg(secondImg, secondDefault, secondImg.__gwaDefaultSrcset);
    }
  }

  function updateCardLinks(card, url) {
    if (!card || !url) return;
    var aMedia = card.querySelector('.card__media-link');
    if (aMedia) aMedia.href = url;
    var aTitle = card.querySelector('.card__heading a');
    if (aTitle) aTitle.href = url;
  }

  function parseCardSwatchMap(card) {
    if (!card) return null;
    if (card.__gwaSwatchMap) return card.__gwaSwatchMap;

    var script = card.querySelector('[data-swatch-map]');
    if (!script) return null;

    try {
      card.__gwaSwatchMap = JSON.parse(script.textContent || '{}');
      return card.__gwaSwatchMap;
    } catch (error) {
      return null;
    }
  }

  function badgeClass(label) {
    var key = String(label || '').trim().toLowerCase();
    if (!key) return 'badge__custom';
    if (key.indexOf('sale') !== -1) return 'badge__is_on_sale';
    if (key.indexOf('bestseller') !== -1) return 'badge__bestseller';
    if (key.indexOf('neue farben') !== -1 || key.indexOf('neue-farben') !== -1) return 'badge__new_farben';
    if (key === 'neu') return 'badge__neu';
    return 'badge__custom';
  }

  function badgeText(label) {
    var text = String(label || '').trim();
    var key = text.toLowerCase();
    var S = (window.gwaStrings && window.gwaStrings.card_product_swatches) || {};
    if (key.indexOf('sale') !== -1) return S.sale || 'Sale';
    if (key.indexOf('bestseller') !== -1) return S.bestseller || 'Bestseller';
    if (key === 'neu') return window.gwaStrings?.badgeNew || 'New';
    if (key === 'neue farben' || key === 'neue-farben') return window.gwaStrings?.badgeNewColors || 'New colors';
    return text;
  }

  function showNode(node) {
    if (!node) return;
    node.hidden = false;
    node.style.display = '';
    node.classList.remove('hidden');
  }

  function hideNode(node) {
    if (!node) return;
    node.hidden = true;
    node.style.display = 'none';
    node.classList.add('hidden');
  }

  function syncCardBadges(card, variantId) {
    if (!card || !variantId) return;

    var map = parseCardSwatchMap(card);
    var badges = map && map.variant_badges && map.variant_badges[String(variantId)];
    if (!Array.isArray(badges)) badges = [];
    badges = badges.map(function (badge) { return String(badge || '').trim(); }).filter(Boolean);

    var wrap = card.querySelector('.card__badge');
    if (!wrap) return;

    wrap.querySelectorAll('[data-variant-badge]').forEach(function (node) {
      node.remove();
    });

    var productBadges = wrap.querySelectorAll('[data-product-badge]');
    if (badges.length) {
      productBadges.forEach(hideNode);

      var anchor = wrap.querySelector('[data-system-badge], .badge__influencer');
      badges.forEach(function (label) {
        var node = document.createElement('span');
        node.className = 'badge ' + badgeClass(label) + ' badge--bottom-left';
        node.setAttribute('data-variant-badge', '');
        node.textContent = badgeText(label);
        wrap.insertBefore(node, anchor || null);
      });
    } else {
      productBadges.forEach(showNode);
    }
  }

  function normalizeFromLabel(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('.price, .price-item, .card__price, .card__price-left');
    var fromLabel = window.gwaStrings && window.gwaStrings.priceFromLabel ? window.gwaStrings.priceFromLabel : 'From';
    var fromReplacement = window.gwaStrings && window.gwaStrings.priceFromShort ? window.gwaStrings.priceFromShort : fromLabel;
    var fromLabels = [fromLabel];
    var documentLanguage = (document.documentElement.lang || '').toLowerCase();

    if (documentLanguage === 'de' || documentLanguage.indexOf('de-') === 0) {
      fromLabels.push('Von');
    }

    var fromPatterns = fromLabels.filter(function (label, index, labels) {
      return label && labels.indexOf(label) === index;
    }).map(function (label) {
      return new RegExp('\\b' + label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'g');
    });

    function normalizeText(value) {
      return fromPatterns.reduce(function (text, pattern) {
        return text.replace(pattern, fromReplacement);
      }, value);
    }

    nodes.forEach(function (node) {
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      var textNode;

      while ((textNode = walker.nextNode())) {
        textNode.nodeValue = normalizeText(textNode.nodeValue);
      }
    });
  }

  function initCards(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-card]').forEach(function (card) {
      // Facet updates can include existing cards: preserve the shopper's selected image and badges.
      if (card.__gwaCardInitialized) return;
      card.__gwaCardInitialized = true;
      restoreDefaultCardImage(card);
      normalizeFromLabel(card);
      syncCardBadges(card, card.getAttribute('data-initial-variant-id'));
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target && event.target.closest && event.target.closest('[data-gwa-swatch]');
    if (!swatch) return;

    var isUnavailable = swatch.classList.contains('is-unavailable');
    var card = swatch.closest && swatch.closest('[data-product-card]');
    if (!card) return;

    var img = swatch.getAttribute('data-variant-img');
    var url = swatch.getAttribute('data-variant-url');

    if (img) swapCardImage(card, img, swatch.getAttribute('data-variant-img-width'));
    if (url && !isUnavailable) updateCardLinks(card, url);
    syncCardBadges(card, swatch.getAttribute('data-variant-id'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards(document);
    });
  } else {
    initCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });

  document.addEventListener('facets:updated', function () {
    initCards(document);
  });

  document.addEventListener('pagination:loaded', function () {
    initCards(document);
  });
})();
